import HeadSection from "../common/HeadSection";
import Brochures from "../home/brochures/Brochures";
import Help from "../playWithUs/Help";
import ItalianStoriesInfo from "./ItalianStoriesInfo";
import { italianStoriesHeadData } from "../../utils/mockData/italianStoriesMocks";

const ItalianStoriesBody = () => {
    return (
        <div className="minWidth100vwFromXL">
            <HeadSection className="mb-5" content={italianStoriesHeadData} />
            <ItalianStoriesInfo />
            <Help />
            <Brochures />
        </div>
    );
};

export default ItalianStoriesBody;
